import { THRESHOLDS_EDIT_REQUEST, THRESHOLDS_EDIT_SUCCESS, THRESHOLDS_EDIT_FAILURE } from './types/WeeklyThresholdsEditActionTypes';

export function postThresholdsEditRequestActionCreator(context, impc, week, minThresholdVal, maxThresholdVal) {
  return {
    type: THRESHOLDS_EDIT_REQUEST,
    payload: {
      appContext: context,
      params: {
        impcCode: impc,
        weeks: week,
        minThreshold: minThresholdVal,
        maxThreshold: maxThresholdVal,
      },
    },
  };
}

export function postThresholdsEditSuccessActionCreator(data) {
  return {
    type: THRESHOLDS_EDIT_SUCCESS,
    payload: data,
  };
}

export function postThresholdsEditFailureActionCreator(error) {
  return {
    type: THRESHOLDS_EDIT_FAILURE,
    payload: error,
    error: true,
  };
}
